import {UIGeneralServicesController} from '../../shared/scripts/UIGeneralServicesController'
import {UINotificationActionController} from '../../shared/scripts/notifications/UINotificationActionController'
import {UIWOnlineFriendController} from './ui_friends/UIWOnlineFriendController'
import {UIWHeaderController} from './ui_html/header/UIWHeaderController'
import {UIManager} from './ui_html/UIManager'

export class UIWGeneralServicesController extends UIGeneralServicesController {
    constructor(uiManager: UIManager | undefined, uiHeaderController: UIWHeaderController | undefined) {
        super()
        this.onlineFriendController = new UIWOnlineFriendController(uiManager?.room, uiHeaderController?.notificationPanelController)

        if(!uiHeaderController?.notificationPanelController) return
        this.notificationActionController = new UINotificationActionController(uiHeaderController.notificationPanelController)
    }

    init() {
        this.onlineFriendController?.init()
    }
}
